import { api } from "@/auth/session";

// Report translation (core-features 2.4). POST /reports/:id/generate_in_language
// ?language=<name> per PropelRails docs/api-contract/06-custom-reports.md.
// Supported by the backend today: english, afrikaans, spanish, german.
export const LANGUAGES = [
  { value: "english", label: "English" },
  { value: "spanish", label: "Español" },
  { value: "german", label: "Deutsch" },
  { value: "afrikaans", label: "Afrikaans" },
] as const;

export async function generateInLanguage(reportId: string, language: string) {
  return api<{ status: "success" | "exists"; field_note_report_id: string; language: string; not_found?: boolean }>(
    `/reports/${reportId}/generate_in_language?language=${encodeURIComponent(language)}`,
    { method: "POST" },
  );
}
